// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"a7b499d9","787":"df4b69e0"}[chunkId] + ".chunk.js";
};